/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  Segment, Grid, Divider, Header, List, Popup,
  Button, Icon, Dimmer, Loader
} from "semantic-ui-react";
import { connect } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";
import ApexCharts from "apexcharts";
import ProblemCard from "./ProblemCard";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import TsExpertReport from "./TsExpertReport";
import Utils from "../utilities/Utils";
import { solveProblemAction } from "../../actions/changeActiveItemActions";

const UtilsInstance = new Utils();

let paWaveFormOptions = {
  series: [{ data: [] }],
  chart: {
    id: Constants.CHART_ID,
    type: "line",
  },
  colors: [Constants.ORANGE_HEX],
  markers: {
    size: 0
  },
  dataLabels: {
    enabled: false
  },
  title: {
    text: Strings.WAVE_FORM,
    align: "center",
    style: {
      fontSize: "14px",
      fontFamily: "Helvetica, Arial, sans-serif"
    }
  },
  stroke: {
    curve: "straight",
    width: 2
  },
  xaxis: {
    type: "numeric",
    title: {
      text: Strings.TIME_US
    },
    crosshairs: {
      show: "true"
    },
    labels: {
      show: true,
      style: {
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        cssClass: "apexcharts-xaxis-label",
      }
    }
  },
  yaxis: {
    min: -1000,
    max: 1000,
    labels: {
      show: true,
      formatter: function (val) {
        return val.toFixed(0) + " " + Strings.MILLIVOLT;
      },
      style: {
        colors: [],
        fontSize: "14px",
        fontFamily: "Helvetica, Arial, sans-serif",
        fontWeight: 400,
        cssClass: "apexcharts-yaxis-label",
      }
    },
    title: {
      text: Strings.VOLTAGE_MV
    },
  },
  annotations: {
    position: "front",
    xaxis: []
  }
};

export class TSExpert extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      nowMillis: Date.now(),
      lastUpdate: new Date(),
      scopeTag: "",
      uptime: "",
      startTime: "",
      channelTag: "",
      problems: [],
      max: 0,
      min: 0,
      groupedProblems: {
        "terminationOFF": [],
        "capacitiveEffect": [],
        "noise": [],
        "highResistance": [],
        "invertedPolarity": [],
        "dados": [],
        "unbalance": [],
      },
      
      currentProblemType: "",
      currentProblemList: [],
      // The report
      report: "",
      equipmentIp: "",
      isGenerateReportDimmerActive: false,
    };
  }

  retrieveData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertWithWaves/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), {
        mode: "cors",
      })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      // Get the start time
      fetch(Constants.REQUEST_IP_ADDRESS + "homePage", {
        mode: "cors",
      })
        .then(res => res.json())
        .then(data => data.uptime)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      problems: resolvedPromisses[0],
      startTime: resolvedPromisses[1]
    }, () => {
      this.checkProblemsListSize();
      this.groupProblemsByType();
    });
  }

  retrieveTagAndUptimeData = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "homePage", {
        mode: "cors",
      })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "getChannelTagsAndNotes/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), {
        mode: "cors",
      })
        .then(res => res.json())
        .then(data => data)
    );

    let resolvedPromisses = await Promise.all(promissesArray);

    this.setState({
      scopeTag: resolvedPromisses[0].networkTag,
      uptime: this.formatToRelativeTime(resolvedPromisses[0].uptime),
      channelTag: resolvedPromisses[1].tag
    });
  }

  getDaysInMonth = (month, year) => {
    if (typeof year == "undefined") year = 1999; // any non-leap-year works as default     
    let currmon = new Date(year, month),
      nextmon = new Date(year, month + 1);
    return Math.floor((nextmon.getTime() - currmon.getTime()) / (24 * 3600 * 1000));
  }

  getDateTimeSince = (target) => { // target should be a Date object
    let now = new Date(), yd, md, dd, hd, nd, sd, out = [];

    yd = now.getFullYear() - target.getFullYear();
    md = now.getMonth() - target.getMonth();
    dd = now.getDate() - target.getDate();
    hd = now.getHours() - target.getHours();
    nd = now.getMinutes() - target.getMinutes();
    sd = now.getSeconds() - target.getSeconds();

    if (md < 0) { yd--; md += 12; }
    if (dd < 0) {
      md--;
      dd += this.getDaysInMonth(now.getMonth() - 1, now.getFullYear());
    }
    if (hd < 0) { dd--; hd += 24; }
    if (nd < 0) { hd--; nd += 60; }
    if (sd < 0) { nd--; sd += 60; }

    if (yd > 0) out.push(yd + Strings.YEAR + (yd === 1 ? "" : "s"));
    if (md > 0) {
      if (md === 1) {
        out.push(md + Strings.MONTH);
      }
      else {
        out.push(md + Strings.MONTHS);
      }
    }
    if (dd > 0) out.push(dd + Strings.DAY + (dd === 1 ? "" : "s"));
    if (hd > 0) out.push(hd + Strings.HOUR + (hd === 1 ? "" : "s"));
    if (nd > 0) out.push(nd + Strings.MINUTE + (nd === 1 ? "" : "s"));
    //if (sd > 0) out.push(sd + " segundo" + (sd === 1 ? "" : "s"));
    return out.join(" ");
  }

  formatToRelativeTime = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return this.getDateTimeSince(new Date(dateWhenWasTurnedOn));
    }
  }

  checkProblemsListSize = () => {
    if (this.state.problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";
    }
    else {
      document.getElementById("problems-list").style.display = "none";
      document.getElementById("no-problem-detected-header").style.display = "block";
    }
  }

  groupProblemsByType = () => {
    let newGroupedProblems = {
      "terminationOFF": [],
      "capacitiveEffect": [],
      "noise": [],
      "highResistance": [],
      "invertedPolarity": [],
      "dados": [],
      "unbalance": [],
    };

    for (let i = 0; i < this.state.problems.length; i++) {
      if (this.state.problems[i].type === Constants.PA_TERMINATION_OFF_PROBLEM_TYPE) {
        newGroupedProblems.terminationOFF.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
        newGroupedProblems.capacitiveEffect.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE) {
        newGroupedProblems.highResistance.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE) {
        newGroupedProblems.invertedPolarity.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.PA_NOISE_PROBLEM_TYPE) {
        newGroupedProblems.noise.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.PA_DADOS_PROBLEM_TYPE) {
        newGroupedProblems.dados.push(this.state.problems[i]);
      }
      else if (this.state.problems[i].type === Constants.PA_UNBALANCE_PROBLEM_TYPE) {
        newGroupedProblems.unbalance.push(this.state.problems[i]);
      }
    }

    this.setState({ groupedProblems: newGroupedProblems });
  }

  // ------ Events List ------
  getListItem = (problemType, groupedProblemList) => {
    if (groupedProblemList.length > 0) {
      return (
        <List.Item>
          <List.Content floated='right' style={{ marginTop: "4px" }}>
            <Button
              size="tiny"
              circular
              color="teal"
              icon="chevron right"
              onClick={this.handleDetailsButtonClick(problemType, groupedProblemList)} />
          </List.Content>
          {this.getListContent(problemType)}
        </List.Item>
      );
    }
    else {
      return "";
    }
  }

  handleDetailsButtonClick = (problemType, groupedProblemList) => () => {
    this.setState({
      currentProblemType: problemType,
      currentProblemList: groupedProblemList
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "none";
      document.getElementById("task-details").style.display = "block";
    });
  }

  getListContent = (problemType) => {
    if (problemType === Constants.PA_TERMINATION_OFF_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.PA_TERMINATOR_OFF_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.PA_CAPACITIVE_EFFECT_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.PA_HIGH_RESISTANCE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.PA_INVERTED_POLARITY_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PA_NOISE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.PA_NOISE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PA_DADOS_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.PA_DADOS_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
    else if (problemType === Constants.PA_UNBALANCE_PROBLEM_TYPE) {
      return (
        <List.Content style={listContentStyle}>
          <List.Header style={{ marginBottom: "2px" }}>{Strings.PA_UNBALANCE_LIST_HEADER}</List.Header>
          <List.Description>
            {Strings.CHECK_YOUR_NETWORK}
          </List.Description>
        </List.Content>
      );
    }
  }

  // ------ Actions ------
  getActions = () => {
    if (this.state.currentProblemType === Constants.PA_TERMINATION_OFF_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PA_TERMINATION_OFF_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.PA_TERMINATION_OFF_SUGGESTION_2}</p>
          <p style={{ textAlign: "justify" }}>{Strings.PA_TERMINATION_OFF_SUGGESTION_3}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.CAPACITIVE_EFFECT_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.CAPACITIVE_EFFECT_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.CAPACITIVE_EFFECT_SUGGESTION_3}</li>
            <li>{Strings.CAPACITIVE_EFFECT_SUGGESTION_4}</li>
            <li>{Strings.CAPACITIVE_EFFECT_SUGGESTION_5}</li>
            <li>{Strings.CAPACITIVE_EFFECT_SUGGESTION_6}</li>
            <li>{Strings.CAPACITIVE_EFFECT_SUGGESTION_7}</li>
            <li>{Strings.CAPACITIVE_EFFECT_SUGGESTION_8}</li>
          </ul>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PA_HIGH_RESISTANCE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.PA_HIGH_RESISTANCE_SUGGESTION_2}</p>
          <p style={{ textAlign: "justify" }}>{Strings.PA_HIGH_RESISTANCE_SUGGESTION_3}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PA_INVERTED_POLARITY_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.PA_INVERTED_POLARITY_SUGGESTION_2}</p>
          <p style={{ textAlign: "justify" }}>{Strings.PA_INVERTED_POLARITY_SUGGESTION_3}</p>
        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.PA_NOISE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PA_NOISE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.PA_NOISE_SUGGESTION_2}</p>

          <ul>
            <li>{Strings.PA_NOISE_SUGGESTION_3}</li>
            <li>{Strings.PA_NOISE_SUGGESTION_4}</li>
            <li>{Strings.PA_NOISE_SUGGESTION_5}</li>
            <li>{Strings.PA_NOISE_SUGGESTION_6}</li>
          </ul>

          <p style={{ textAlign: "justify" }}>{Strings.PA_NOISE_SUGGESTION_7}</p>

        </Segment>
      );
    }
    else if (this.state.currentProblemType === Constants.PA_DADOS_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PA_DADOS_SUGGESTION_1}</Header>

          <ul>
            <li>{Strings.PA_DADOS_SUGGESTION_2}</li>
            <li>{Strings.PA_DADOS_SUGGESTION_3}</li>
          </ul>

        </Segment>
      );
    }
    if (this.state.currentProblemType === Constants.PA_UNBALANCE_PROBLEM_TYPE) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.PA_UNBALANCE_SUGGESTION_1}</Header>
          <p style={{ textAlign: "justify" }}>{Strings.PA_UNBALANCE_SUGGESTION_2}</p>
        </Segment>
      );
    }
  }

  getProblemCards = () => {
    if (this.state.currentProblemList.length > 1) {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem._id}
                nowMillis={this.state.nowMillis}
                startTime={this.state.startTime}
                problem={problem}
                channel={parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL))} />
            ))
          }
          <Button
            fluid
            color='green'
            onClick={this.handleBatchCheckButtonClick}>
            {Strings.BATCH_CHECK}
          </Button>
        </Segment>
      );
    }
    else {
      return (
        <Segment>
          <Header as="h3" textAlign="center">{Strings.DETAILING}</Header>
          {
            this.state.currentProblemList.map(problem => (
              <ProblemCard
                key={problem._id}
                nowMillis={this.state.nowMillis}
                startTime={this.state.startTime}
                problem={problem}
                channel={parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL))} />
            ))
          }
        </Segment>
      );
    }
  }

  handleCloseButtonClick = () => {
    this.setState({
      currentProblemType: "",
      currentProblemList: []
    }, () => {
      document.getElementById("no-task-selected-header").style.display = "block";
      document.getElementById("task-details").style.display = "none";
    });
  }

  handleBatchCheckButtonClick = () => {
    let data = JSON.stringify({
      type: this.state.currentProblemType,
      problems: this.state.currentProblemList
    });

    fetch(Constants.REQUEST_IP_ADDRESS + "solveAllProblems_POST/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    })
      .then(UtilsInstance.checkStatus2)
      .then(() => {
        alert(Strings.ALL_EVENTS_WERE_CHECKED);

        // Mostre que não existem eventos
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      })
      .catch((error) => {
        let result = JSON.parse(error.message);

        let message = "";

        if (result.notSolved.length > 0) {

          message += this.getInitialErrorMessage(result.type) + "\n";

          for (let i = 0; i < result.notSolved.length; i++) {
            message += this.getErrorMessage(result.notSolved[i]);
          }

          message += Strings.CHECK_EVENT_OBS;
        }

        alert(message);

        // Feche a seção de solução
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";

        // Limpe as variáveis de eventos e pegue os dados atualizados
        this.setState({
          currentProblemType: "",
          currentProblemList: [],
        }, () => {
          this.retrieveData();
        });

      });
  }

  getInitialErrorMessage = (problemType) => {
    if (problemType === Constants.PA_TERMINATION_OFF_PROBLEM_TYPE) {
      return Strings.UNABLE_TO_CHECK_TERMINATION_OFF_EVENTS;
    }
    else if (problemType === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return Strings.UNABLE_TO_CHECK_CAPACITIVE_EFFECT_EVENTS;
    }
    else if (problemType === Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE) {
      return Strings.UNABLE_TO_CHECK_HIGH_RESISTANCE_EVENTS;
    }
    else if (problemType === Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE) {
      return Strings.UNABLE_TO_CHECK_INVERTED_POLARITY_EVENTS;
    }
    else if (problemType === Constants.PA_NOISE_PROBLEM_TYPE) {
      return Strings.UNABLE_TO_CHECK_NOISE_EVENTS;
    }
    else if (problemType === Constants.PA_DADOS_PROBLEM_TYPE) {
      return Strings.UNABLE_TO_CHECK_DADOS_EVENTS;
    }
    else if (problemType === Constants.PA_UNBALANCE_PROBLEM_TYPE) {
      return Strings.UNABLE_TO_CHECK_UNBALANCE_EVENTS;
    }
    else {
      return "";
    }
  }

  getErrorMessage = (problem) => {
    if (problem.type === Constants.PA_TERMINATION_OFF_PROBLEM_TYPE) {
      return `• ${Strings.ADDRESS}: ${problem.address}\n`;
    }
    else if (problem.type === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return `• ${Strings.ADDRESS}: ${problem.address}\n`;
    }
    else if (problem.type === Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE) {
      return `• ${Strings.ADDRESS}: ${problem.address}\n`;
    }
    else if (problem.type === Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE) {
      return `• ${Strings.ADDRESS}: ${problem.address}\n`;
    }
    else if (problem.type === Constants.PA_NOISE_PROBLEM_TYPE) {
      return `• ${Strings.ADDRESS}: ${problem.address}\n`;
    }
    else if (problem.type === Constants.PA_DADOS_PROBLEM_TYPE) {
      return `• ${Strings.ADDRESS}: ${problem.address}\n`;
    }
    else if (problem.type === Constants.PA_UNBALANCE_PROBLEM_TYPE) {
      return `• ${Strings.ADDRESS}: ${problem.address}\n`;
    }
    else {
      return "";
    }
  }

  // ------ TS Expert Report ------
  generateTsExpertReport = async () => {
    this.setState({ report: "" }, async () => {
      this.setGeneratingDimmerState(true);

      let problems = await fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertWithWaves/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let networkData = await fetch(Constants.REQUEST_IP_ADDRESS + "networkData/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let homePage = await fetch(Constants.REQUEST_IP_ADDRESS + "homePage", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let configData = await fetch(Constants.REQUEST_IP_ADDRESS + "config", { mode: "cors" })
        .then(res => res.json())
        .then(data => data);

      let wifiStatus = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiStatus", { mode: "cors" })
        .then(res => res.json())
        .then(data => data.status);

      let wifiConfigData = "";

      if (wifiStatus === Constants.CONNECTED_STATUS) {
        wifiConfigData = await fetch(Constants.REQUEST_IP_ADDRESS + "wifiConfig", { mode: "cors" })
          .then(res => res.json())
          .then(data => data);
      }
      else {
        wifiConfigData = {
          "wifiMode": "",
          "hiddenSSID": false,
          "wifiName": "",
          "wifiAddr": "",
          "wifiNetmask": "",
          "wifiGateway": "",
          "wifiDNS": "",
          "wifiPwd": ""
        };
      }

      let reportGroupedProblems = {
        "terminationOFF": [],
        "capacitiveEffect": [],
        "noise": [],
        "highResistance": [],
        "invertedPolarity": [],
        "dados": [],
        "unbalance": [],
      };

      for (let i = 0; i < problems.length; i++) {
        if (problems[i].type === Constants.PA_TERMINATION_OFF_PROBLEM_TYPE) {
          reportGroupedProblems.terminationOFF.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
          reportGroupedProblems.capacitiveEffect.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE) {
          reportGroupedProblems.highResistance.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE) {
          reportGroupedProblems.invertedPolarity.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_NOISE_PROBLEM_TYPE) {
          reportGroupedProblems.noise.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_DADOS_PROBLEM_TYPE) {
          reportGroupedProblems.dados.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_UNBALANCE_PROBLEM_TYPE) {
          reportGroupedProblems.unbalance.push(problems[i]);
        }
      }

      let terminationOFFImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.terminationOFF,Constants.PA_TERMINATION_OFF_PROBLEM_TYPE);
      let capacitiveEffectImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.capacitiveEffect,Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE);
      let highResistanceImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.highResistance,Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE);
      let invertedPolarityImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.invertedPolarity,Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE);
      let noiseImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.noise,Constants.PA_NOISE_PROBLEM_TYPE);
      let unbalanceImages = await this.getOscilloscopeImgURIs(reportGroupedProblems.unbalance,Constants.PA_UNBALANCE_PROBLEM_TYPE);

      this.setState({
        equipmentIp: configData.addr,
        report:
          <TsExpertReport
            nowMillis={this.state.nowMillis}
            startTime={this.state.startTime}
            terminationOFF={reportGroupedProblems.terminationOFF}
            terminationOFFImages={terminationOFFImages}
            capacitiveEffect={reportGroupedProblems.capacitiveEffect}
            capacitiveEffectImages={capacitiveEffectImages}
            highResistance={reportGroupedProblems.highResistance}
            highResistanceImages={highResistanceImages}
            invertedPolarity={reportGroupedProblems.invertedPolarity}
            invertedPolarityImages={invertedPolarityImages}
            noise={reportGroupedProblems.noise}
            noiseImages={noiseImages}
            dados={reportGroupedProblems.dados}
            unbalance={reportGroupedProblems.unbalance}
            unbalanceImages={unbalanceImages}
            masters={networkData.nMasters}
            slaves={networkData.nSlaves}
            tag={homePage.tag}
            uptime={homePage.uptime}
            configData={configData}
            wifiConfigData={wifiConfigData}
            channel={parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL))}
          />
      });
    });
  }

  setGeneratingDimmerState = (isActive) => {
    if (!isActive) {
      this.setState({ isGenerateReportDimmerActive: isActive }, () => {
        alert(Strings.GENERATING_ACTIONS_LIST_SUCCESS);
      });
    }
    else {
      this.setState({ isGenerateReportDimmerActive: isActive });
    }
  }

  getOscilloscopeImgURIs =  async (groupedProblem, problemType) => {
    let imgURIs = [];

    // Only try to generate the images if the array is not empty
    if (groupedProblem.length > 0) {
      document.getElementById("chart").style.display = "block";

      // Render the chart
      let chart = new ApexCharts(document.querySelector("#chart"), paWaveFormOptions);
      chart.render();

      for (let i = 0; i < groupedProblem.length; i++) {
        let imgURIObj = {
          "id": groupedProblem[i]._id,
          "address": groupedProblem[i].address,
          "wave": "",
          "jitter": problemType === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE ? groupedProblem[i].jitter : "",
          "amplitude": problemType === (Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE || Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE || Constants.PA_NOISE_PROBLEM_TYPE) ? "" : groupedProblem[i].amplitude,
          "amplitudeIdle": problemType === Constants.PA_NOISE_PROBLEM_TYPE ? groupedProblem[i].amplitudeIdle : "",
          "unbalance": problemType === Constants.PA_UNBALANCE_PROBLEM_TYPE ? groupedProblem[i].unbalance : "",
          "ntp": groupedProblem[i].ntp,
          "time": groupedProblem[i].time,
          "channel": groupedProblem[i].channel
        };

        let options = this.getFormatedPAOptions(groupedProblem[i].wave,paWaveFormOptions);

        options = {
          ...options,
          colors: [Constants.ORANGE_HEX],
          title: {
            text: Strings.WAVE_FORM,
          },
          series: [
            {
              name: Strings.WAVE_FORM,
              data: (this.formatPAWaveTimes(groupedProblem[i].wave))
            }
          ]
        };

        chart.updateOptions(options, false, false, false);

        imgURIObj.wave = await chart.dataURI();

        // Save both waves URIs
        imgURIs.push(imgURIObj);
      }

      document.getElementById("chart").style.display = "none";

      chart.destroy();

      return imgURIs;
    }
    else {
      return imgURIs;
    }
  }

  getFormatedPAOptions = (wave, paWaveFormOptions) => {
    let options = {};

    // Set the time values to microsseconds
    options = {
      ...paWaveFormOptions,
      xaxis: {
        type: "numeric",
        title: {
          text: Strings.TIME_US
        },
        crosshairs: {
          show: "true"
        }
      }
    };

    return options;
  }


  formatPAWaveTimes = (wave) => {
    // Set the time values to microsseconds
    for (let i = 0; i < wave.length; i++) {
      wave[i][0] = wave[i][0] / (10 ** 3);
    }
    return wave;
  }

  // ------ TS Expert Modal ------
  retrieveData2 = async () => {
    let promissesArray = [];

    promissesArray.push(
      fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertWithWaves/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), {
        mode: "cors",
      })
        .then(res => res.json())
        .then(data => data)
    );

    promissesArray.push(
      // Get the start time
      fetch(Constants.REQUEST_IP_ADDRESS + "homePage", {
        mode: "cors",
      })
        .then(res => res.json())
        .then(data => data.uptime)
    );

    let resolvedPromisses = await Promise.all(promissesArray);
    let problems = resolvedPromisses[0];
    let startTime = resolvedPromisses[1];

    if (problems.length > 0) {
      document.getElementById("problems-list").style.display = "block";
      document.getElementById("no-problem-detected-header").style.display = "none";

      let newGroupedProblems = {
        "terminationOFF": [],
        "capacitiveEffect": [],
        "noise": [],
        "highResistance": [],
        "invertedPolarity": [],
        "dados": [],
        "unbalance": [],
      };

      for (let i = 0; i < problems.length; i++) {
        if (problems[i].type === Constants.PA_TERMINATION_OFF_PROBLEM_TYPE) {
          newGroupedProblems.terminationOFF.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
          newGroupedProblems.capacitiveEffect.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE) {
          newGroupedProblems.highResistance.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE) {
          newGroupedProblems.invertedPolarity.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_NOISE_PROBLEM_TYPE) {
          newGroupedProblems.noise.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_DADOS_PROBLEM_TYPE) {
          newGroupedProblems.dados.push(problems[i]);
        }
        else if (problems[i].type === Constants.PA_UNBALANCE_PROBLEM_TYPE) {
          newGroupedProblems.unbalance.push(problems[i]);
        }
      }

      let currentProblemsList = this.getCurrentProblemsList(newGroupedProblems);
      //console.log(currentProblemsList);

      if (currentProblemsList.length > 0) {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: this.state.currentProblemType,
          currentProblemList: currentProblemsList,
          startTime: startTime
        });
      }
      else {
        this.setState({
          nowMillis: Date.now(),
          lastUpdate: new Date(),
          problems: problems,
          groupedProblems: newGroupedProblems,
          currentProblemType: "",
          currentProblemList: [],
          startTime: startTime,
        }, () => {
          document.getElementById("no-task-selected-header").style.display = "block";
          document.getElementById("task-details").style.display = "none";
        });
      }
    }
    else {
      this.setState({
        nowMillis: Date.now(),
        lastUpdate: new Date(),
        problems: [],
        groupedProblems: {
          "terminationOFF": [],
          "capacitiveEffect": [],
          "noise": [],
          "highResistance": [],
          "invertedPolarity": [],
          "dados": [],
          "unbalance": [],
        },
        currentProblemType: "",
        currentProblemList: [],
        startTime: startTime,
      }, () => {
        document.getElementById("problems-list").style.display = "none";
        document.getElementById("no-problem-detected-header").style.display = "block";
        document.getElementById("no-task-selected-header").style.display = "block";
        document.getElementById("task-details").style.display = "none";
      });
    }
  }

  getCurrentProblemsList = (groupedProblems) => {
    if (this.state.currentProblemType === Constants.PA_TERMINATION_OFF_PROBLEM_TYPE) {
      return groupedProblems.terminationOFF;
    }
    else if (this.state.currentProblemType === Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return groupedProblems.capacitiveEffect;
    }
    else if (this.state.currentProblemType === Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE) {
      return groupedProblems.highResistance;
    }
    else if (this.state.currentProblemType === Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE) {
      return groupedProblems.invertedPolarity;
    }
    else if (this.state.currentProblemType === Constants.PA_NOISE_PROBLEM_TYPE) {
      return groupedProblems.noise;
    }
    else if (this.state.currentProblemType === Constants.PA_DADOS_PROBLEM_TYPE) {
      return groupedProblems.dados;
    }
    else if (this.state.currentProblemType === Constants.PA_UNBALANCE_PROBLEM_TYPE) {
      return groupedProblems.unbalance;
    }
    else {
      return [];
    }
  }

  checkProblem = async (problem) => {
    this.solveProblem(problem, false);
  }

  solveProblem = (problem, forceSolve) => {
    fetch(Constants.REQUEST_IP_ADDRESS + "solveProblem_POST/" + parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL)), {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify({
        problem: problem,
        forceSolve: forceSolve
      })
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.PROBLEM_CHECKED);
        this.props.onProblemSolve(false, {});
        document.getElementById(problem._id).style.display = "none";
        this.retrieveData2();
      })
      .catch((error) => {
        alert(Strings.PROBLEM_CHECK_ERROR + Strings.ERROR_REASON + error);
        this.props.onProblemSolve(false, {});
      });
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    sessionStorage.removeItem("auth");
    this.retrieveData();
    this.retrieveTagAndUptimeData();
    // store intervalId in the state so it can be accessed later
    this.setState({ intervalID: setInterval(this.retrieveTagAndUptimeData, 5000) });
  }

  componentWillUnmount() {
    clearInterval(this.state.intervalID);
  }

  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState) {
    // Só tente resolver o problema quando o solve era falso e agora for true
    if (prevProps.solveProblem.solve !== this.props.solveProblem.solve
      && this.props.solveProblem.solve === true) {
      this.checkProblem(this.props.solveProblem.problem);
    }
  }

  render() {
    return (
      <div>

        <Grid style={gridStyle} columns={3} doubling>

          <Grid.Column verticalAlign="middle" style={{ paddingBottom: "0" }}>

            <Grid columns={2}>
              <Grid.Column width={3} textAlign="center" verticalAlign="middle">
                <Popup position='bottom left' hoverable pinned wide="very"
                  trigger={
                    <Icon name="question circle" size="huge" color="teal" />
                  }>
                  <Popup.Content>
                    <p>{Strings.TS_EXPERT_POPUP_1}</p>
                    <p>{Strings.TS_EXPERT_POPUP_2}</p>
                    <p>{Strings.TS_EXPERT_POPUP_3}</p>
                    <p><b>{Strings.PS} </b>{Strings.TS_EXPERT_POPUP_4}</p>
                  </Popup.Content>
                </Popup >
              </Grid.Column>
              <Grid.Column width={13} verticalAlign="middle">
                <Header as='h4' style={networkTagStyle}><b>{Strings.SCOPE_TAG}</b> {this.state.scopeTag}</Header>
                <Header as='h4' style={segmentTagStyle}><b>{Strings.CHANNEL_TAG_2}</b> {this.state.channelTag}</Header>
              </Grid.Column>
            </Grid>

          </Grid.Column>

          <Grid.Column verticalAlign="middle" textAlign="center" style={{ paddingBottom: "0" }}>
            <Button
              content={Strings.EXPORT_ACTIONS_LIST}
              color="teal"
              onClick={this.generateTsExpertReport} />

            <Dimmer page active={this.state.isGenerateReportDimmerActive} >
              <Loader size="big">{Strings.GENERATING_ACTIONS_LIST_WAITING}</Loader>
            </Dimmer>

            <PDFDownloadLink
              className="download-link"
              style={pdfLinkStyle}
              document={this.state.report}
              fileName={
                `${Strings.ACTIONS_LIST_NAME} ${parseInt(localStorage.getItem(Constants.ACTIVE_CHANNEL))} (${this.state.equipmentIp}).pdf`
              }>
              {({ loading }) => {
                if (loading) {
                  return Strings.GENERATING_ACTIONS_LIST_WAITING_2;
                }
                else {
                  if (this.state.isGenerateReportDimmerActive) {
                    let downloadLink = document.getElementsByClassName("download-link")[0];
                    downloadLink.onclick = () => {
                      setTimeout(() => {
                        if (downloadLink !== null && downloadLink !== undefined) {
                          downloadLink.innerHTML = "";
                        }
                      }, 1500);
                    };
                    this.setGeneratingDimmerState(false);
                  }
                  return Strings.SAVE_ACTIONS_LIST;
                }
              }}
            </PDFDownloadLink>
          </Grid.Column>

          <Grid.Column style={{ paddingBottom: "0" }}>
            <Segment style={floatStyle} size="large" compact textAlign="center">
              <Icon color="green" name="arrow alternate circle up" />
              {Strings.TIME_ON} {this.state.uptime}
            </Segment>
          </Grid.Column>

        </Grid>

        <Grid style={gridStyle} columns={2} doubling>

          <Grid.Column>
            <Segment style={leftSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.EVENTS_LIST}
              </Header>
              <Divider clearing />

              <Segment id="problems-list" style={listSegmentStyle} basic>
                <List size="medium" animated divided style={listStyle}>
                  {this.getListItem(Constants.PA_TERMINATION_OFF_PROBLEM_TYPE, this.state.groupedProblems.terminationOFF)}
                  {this.getListItem(Constants.PA_CAPACITIVE_EFFECT_PROBLEM_TYPE, this.state.groupedProblems.capacitiveEffect)}
                  {this.getListItem(Constants.PA_HIGH_RESISTANCE_PROBLEM_TYPE, this.state.groupedProblems.highResistance)}
                  {this.getListItem(Constants.PA_INVERTED_POLARITY_PROBLEM_TYPE, this.state.groupedProblems.invertedPolarity)}
                  {this.getListItem(Constants.PA_NOISE_PROBLEM_TYPE, this.state.groupedProblems.noise)}
                  {this.getListItem(Constants.PA_DADOS_PROBLEM_TYPE, this.state.groupedProblems.dados)}
                  {this.getListItem(Constants.PA_UNBALANCE_PROBLEM_TYPE, this.state.groupedProblems.unbalance)}
                </List>
              </Segment>

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-problem-detected-header"
                as='h2'
                icon
                color="teal">
                <Icon name="check circle" color="teal" />
                {Strings.NO_PROBLEM_DETECTED}
                <Header.Subheader>
                  <p>{Strings.NO_EVENTS_TO_BE_ANALYZED}</p>
                </Header.Subheader>
              </Header>

            </Segment>
          </Grid.Column>

          <Grid.Column>
            <Segment style={rightSegmentStyle}>

              <Header as='h2' textAlign="center" color="teal">
                {Strings.ACTIONS}
              </Header>
              <Divider clearing />

              <Header
                textAlign="center"
                style={noTaskHeaderSelectedStyle}
                id="no-task-selected-header"
                as="h2"
                icon
                color="teal">
                <Icon name='edit outline' color="teal" />
                {Strings.NO_EVENT_SELECTED}
                <Header.Subheader>
                  {Strings.CHOOSE_AN_EVENT}
                </Header.Subheader>
              </Header>

              <Segment id="task-details" style={taskSegmentStyle}>

                <Button
                  size="tiny"
                  circular
                  icon="times"
                  onClick={this.handleCloseButtonClick} />

                {this.getActions()}
                {this.getProblemCards()}

              </Segment>

            </Segment>

          </Grid.Column>

        </Grid>

        <div style={lastUpdateContainerStyle}>
          <div>
            <p>
              <b>{Strings.LAST_UPDATED}</b>
              {this.state.lastUpdate.toLocaleString("pt-BR")}
              {Strings.THIS_COMPUTER_TIME}
            </p>
          </div>
          <div>
            <Button
              style={{ marginLeft: "8px" }}
              circular
              color="teal"
              icon="refresh"
              onClick={this.retrieveData2} />
          </div>
        </div>

        <div id="chart" style={chartsStyle}></div>

      </div >
    );
  }
}

const mapStateToProps = state => ({
  channel: state.activeMenuItem.channel,
  solveProblem: state.solveProblem,
});

const mapActionsToProps = {
  onProblemSolve: solveProblemAction
};

const gridStyle = {
  marginLeft: "2vw",
  marginRight: "2vw"
};

const listStyle = {
  marginLeft: "24px",
  marginRight: "24px"
};

const leftSegmentStyle = {
  height: "66vh"
};

const rightSegmentStyle = {
  height: "66vh"
};

const listSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const taskSegmentStyle = {
  display: "none",
  overflowY: "scroll",
  height: "52vh"
};

const noTaskHeaderSelectedStyle = {
  marginTop: "14vh"
};

const listContentStyle = {
  marginTop: "4px",
  marginBottom: "4px"
};

const pdfLinkStyle = {
  marginLeft: "8px"
};

const networkTagStyle = {
  color: "#576577",
  marginBottom: "0"
};

const segmentTagStyle = {
  marginTop: "0",
  color: "#576577",
};

const floatStyle = {
  float: "right",
  textAlign: "right"
};

const lastUpdateContainerStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  marginTop: "8px"
};

const chartsStyle = {
  width: "1026px",
  height: "580px",
  display: "none",
  visibility: "hidden"
};

export default connect(mapStateToProps, mapActionsToProps)(withRouter(TSExpert));
